import React from "react";
import { Tag } from "antd";
import { JobStatus } from "~/utils/constants";

interface StatusBadgeProps {
  status: JobStatus;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const statusStyles = {
    [JobStatus.COMPLETED]: { color: "green", label: "Completed" },
    [JobStatus.IN_PROGRESS]: { color: "blue", label: "In Progress" },
    [JobStatus.SCHEDULED]: { color: "yellow", label: "Scheduled" },
  };

  const { color, label } = statusStyles[
    status as keyof typeof statusStyles
  ] || {
    color: "default",
    label: status,
  };

  return (
    <Tag color={color} className="text-xs font-medium">
      {label}
    </Tag>
  );
};
